import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-image-fullscreen-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './image-fullscreen-modal.component.html',
  styleUrls: ['./image-fullscreen-modal.component.scss']
})
export class ImageFullscreenModalComponent {
  @Input() imageUrl: string | undefined = '';
  @Input() isOpen: boolean = false;
  @Input() close!: () => void;

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/catalog-default-product.png';
  }
}
